import {useSelector} from 'react-redux';


import {cartSelectors} from '../index';

import useIsCartEmpty from './useIsCartEmpty';


/**
 * @param cartId {string} Cart id to check for checkout readiness
 * @return {boolean} True if cart can be checked out, false if not
 */
function useCanCheckoutCart(cartId) {

    const cart = useSelector(state => cartSelectors.getCart(state, cartId));
    const isCartEmpty = useIsCartEmpty(cartId);

    return cart && !isCartEmpty && cart.isValid;
}


export default useCanCheckoutCart;
